export default __webpack_public_path__ + "static/media/success-fulCases1.2dd3ed10.png";